import { css } from 'linaria';
import fonts from 'style/fonts';
export const home = "h1rnu5b7";
export const wrapper = "wvpt4yt";
export const carousel = "c5qqn13";
export const carouselWrapper = "c1l0qajv";
export const image = "iupi7lm";
export const dots = "dr6a41n";
export const dotInner = "dgi0br1";
export const dot = "d14adkdr";

require("/Users/florianmorel/Work/Websites/rudy-vermorel-2019/.linaria-cache/src/components/home/styles.linaria.css");